angular.module("app").service("permissionsApi", permissionsApi);

permissionsApi.$inject = ["$resource", "settings"];

function permissionsApi($resource, settings) {
  const resource = $resource(`${settings.apiBase}/permissions`);
  return resource;
}
